import { SerializableObject } from './serializable-object';
import { Dictionary } from '../interfaces/dictionary.interface';

export class MobizPermission extends SerializableObject {
  public module: string;
  public key: string;
  public name: Dictionary<string>;
  public description: Dictionary<string>;
}
